import React, { forwardRef } from 'react';
import cx from 'classnames';

import useThemeBlock from '@/hooks/useThemeBlock';
import { Section } from '@/helpers/Section';

import { getStyles as getDfltStyles } from './styles.css';
import block from './block.json';

interface ForwardedSectionTwoColumns
	extends React.ForwardRefExoticComponent<
			SectionTwoColumnsProps & React.RefAttributes<HTMLDivElement>
		>,
		BlockConfigs {}

/**
 * COMPONENT
 */
export const SectionTwoColumns = forwardRef<
	HTMLDivElement,
	SectionTwoColumnsProps
>(
	(
		{
			anchor,
			className,
			uptitle,
			title,
			introduction,
			slug,
			variant: currentVariant = 'default',
			children,
			firstColIsRight = false,
			titleTag = 'h2',
			theme = {},
			getStyles = getDfltStyles,
		},
		ref
	) => {
		const { variant, blockTheme } = useThemeBlock(
			slug,
			theme,
			currentVariant
		);

		const trimmedSlug = slug.split('/');
		const modifierSlug = trimmedSlug[trimmedSlug.length - 1];

		const rootClass = cx(
			'supt-section supt-section--twoCol',
			`supt-section--${modifierSlug}`,
			{ 'supt-section--twoCol--firstColIsRight': firstColIsRight },
			getStyles(blockTheme),
			className
		);

		return (
			<Section
				id={anchor}
				className={rootClass}
				variant={variant}
				slug={slug}
				ref={ref}
			>
				<div className="supt-section__inner">
					{(uptitle || title) && (
						<div className="supt-section__headline">
							{uptitle && <Section.Uptitle text={uptitle} />}
							{title && (
								<Section.Title
									text={title}
									titleTag={titleTag}
								/>
							)}
							{introduction && (
								<Section.Introduction text={introduction} />
							)}
						</div>
					)}
					{children}
				</div>
			</Section>
		);
	}
) as ForwardedSectionTwoColumns;

SectionTwoColumns.slug = block.slug;
SectionTwoColumns.title = block.title;
